module.exports = __webpack_public_path__ + "static/img/buying_two.4a464c74.jpg";